import React from 'react';
import PropTypes from 'prop-types';
import { Link,  Typography, useTheme } from '@mui/material';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { ENV } from '../../constants';

const styles = {
  button: {
    alignItems: 'center',
    display: 'flex',
    height: '40px',
    justifyContent: 'center',
    textDecoration: 'none !important',
    width: '100%',
  },
  primary: {
    backgroundColor: (theme) => theme.palette.secondary.main,
    color: (theme) => theme.palette.primary.main,
  },
  secondary: {
    backgroundColor: (theme) => theme.palette.primary.main,
    color: '#fff',
  },
}

export default function AddToCalendar({ eventId, type }) {
  const theme = useTheme();

  return (
    <Link
      href={`${ENV.API_URL}/events/${eventId}/calendar`}
      sx={[
        styles.button,
        type === 'secondary' ? styles.secondary : styles.primary
      ]}
    >
      <Typography
        variant="h4"
        style={{
          display: 'flex',
          alignItems: 'center',
          color: theme.palette[type || 'primary'].main,
        }}
      >
        Add to Calendar
        <CalendarTodayOutlinedIcon style={{ marginLeft: '10px' }} />
      </Typography>
    </Link>
  );
}

AddToCalendar.propTypes = {
  eventId: PropTypes.string,
  type: PropTypes.string,
};
